import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';

const faqData = [
  {
    question: '韩漫网是什么？',
    answer: '韩漫网是一个免费在线韩国漫画阅读平台，提供高清韩国漫画大全。我们致力于为用户提供资源齐全、界面简洁的漫画阅读体验，涵盖恋爱、奇幻、动作、搞笑、悬疑、剧情、日常、古风、恐怖等多种类型。',
  },
  {
    question: '韩漫网是否需要注册或付费？',
    answer: '韩漫网完全免费，无需注册即可畅读所有漫画。我们不收取任何费用，致力于为漫画爱好者提供无障碍的阅读体验。',
  },
  {
    question: '韩漫网的漫画多久更新一次？',
    answer: '韩漫网每日更新漫画内容。我们的编辑团队会持续跟进热门韩国漫画的最新章节，确保用户能够及时阅读到最新内容。',
  },
  {
    question: '韩漫网支持哪些设备阅读？',
    answer: '韩漫网采用响应式设计，完美支持电脑、平板和手机等多种设备。无论您使用什么设备，都能获得优质的漫画阅读体验。',
  },
  {
    question: '如何联系韩漫网团队？',
    answer: '您可以通过本页面的联系表单或发送邮件至 contact@hanmanwang.com 与我们取得联系。我们会尽快回复您的咨询。',
  },
];

export default function AboutPage() {
  const [formState, setFormState] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormState('success');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9pdtleb4qjhggaeps80', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'phone_alt')
            .map(([key, value]) => [key, String(value)])
        ).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
      if (response.ok && parsed?.code === 'OK') {
        setFormState('success');
        form.reset();
      } else {
        setFormState('error');
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormState('error');
      setFormError('网络错误，请稍后重试');
    }
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 韩漫网 | 免费在线漫画阅读平台"
        description="了解韩漫网，免费在线韩国漫画阅读平台。品牌介绍、用户口碑、联系方式。高清韩国漫画大全，资源齐全界面简洁，您的休闲娱乐可靠选择。"
        keywords="韩漫网,关于韩漫网,免费漫画平台,韩国漫画网站,联系我们"
        canonicalPath="/about"
        ogType="website"
        faqData={faqData}
      />

      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { name: '首页', href: '/' },
                { name: '关于我们' },
              ]}
            />
            <div className="pb-6">
              <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                关于韩漫网
              </h1>
              <p className="text-sm text-foreground-400 mt-1">了解我们的品牌故事与使命</p>
            </div>
          </div>
        </div>

        <section className="py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="mb-12">
                <h2 className="text-lg font-heading font-bold text-foreground-950 mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    韩漫网成立于2024年，是一个专注于免费在线韩国漫画阅读的综合平台。我们深知漫画爱好者对高质量阅读体验的追求，因此致力于打造一个<strong>资源齐全</strong>、<strong>界面简洁</strong>、<strong>完全免费</strong>的韩国漫画大全网站。
                  </p>
                  <p>
                    我们的团队由一群热爱漫画的年轻人组成，他们拥有丰富的互联网产品开发经验和深厚的内容运营能力。从海量的韩国漫画资源中，我们精心挑选优质内容，涵盖恋爱、奇幻、动作、搞笑、悬疑、剧情、日常、古风、恐怖等多种类型，满足不同读者的阅读偏好。
                  </p>
                  <p>
                    韩漫网坚持"读者至上"的理念，持续优化阅读体验。无论是电脑端还是移动端，我们都提供了流畅的在线阅读功能，让您随时随地畅享高清韩国漫画。我们相信，好的漫画值得被更多人看到，而韩漫网就是连接优质漫画与读者的桥梁。
                  </p>
                </div>
              </div>

              <div className="mb-12">
                <h2 className="text-lg font-heading font-bold text-foreground-950 mb-4">
                  用户口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[
                    {
                      name: '漫画爱好者小王',
                      text: '韩漫网真的很良心！分类清晰，更新及时，画质也很棒。每天下班后刷几话韩漫已经成为我的日常习惯了。',
                      rating: 5,
                    },
                    {
                      name: '读者小李',
                      text: '找了好久终于找到一个干净好用的韩漫网站。没有乱七八糟的广告，阅读体验非常好，推荐给了很多朋友。',
                      rating: 5,
                    },
                    {
                      name: '资深漫迷阿张',
                      text: '资源真的很齐全，连一些冷门的韩漫都能找到。界面也很简洁，搜索和浏览都很方便，五星好评！',
                      rating: 5,
                    },
                    {
                      name: '新用户小陈',
                      text: '朋友推荐的韩漫网，第一次用就被圈粉了。不需要注册直接就能看，太方便了。漫画种类也很多，总有我喜欢的。',
                      rating: 5,
                    },
                  ].map((review, index) => (
                    <div key={index} className="p-5 rounded-lg bg-background-100">
                      <div className="flex items-center gap-1 mb-2">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                        &ldquo;{review.text}&rdquo;
                      </p>
                      <span className="text-xs text-foreground-400 font-medium">
                        — {review.name}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-lg font-heading font-bold text-foreground-950 mb-4">
                  联系我们
                </h2>
                <div className="bg-background-100 rounded-lg p-6 md:p-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                        <p className="text-sm text-foreground-500">contact@hanmanwang.com</p>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-800 mb-1">工作时间</h3>
                        <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-800 mb-1">反馈建议</h3>
                        <p className="text-sm text-foreground-500">
                          如果您有任何建议或意见，欢迎通过右侧表单或邮件与我们联系。我们会认真对待每一条反馈，持续改进韩漫网的服务。
                        </p>
                      </div>
                    </div>

                    <div>
                      <form
                        id="contact-form"
                        data-readdy-form
                        onSubmit={handleSubmit}
                        className="space-y-4"
                      >
                        <div>
                          <label htmlFor="name" className="block text-xs font-medium text-foreground-600 mb-1">
                            姓名
                          </label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            required
                            className="w-full px-3 py-2 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                            placeholder="请输入您的姓名"
                          />
                        </div>

                        <div>
                          <label htmlFor="email" className="block text-xs font-medium text-foreground-600 mb-1">
                            邮箱
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            className="w-full px-3 py-2 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                            placeholder="请输入您的邮箱"
                          />
                        </div>

                        <input
                          type="text"
                          name="phone_alt"
                          tabIndex={-1}
                          autoComplete="off"
                          aria-hidden="true"
                          readOnly
                          className="honeypot-field"
                        />

                        <div>
                          <label htmlFor="message" className="block text-xs font-medium text-foreground-600 mb-1">
                            留言内容
                          </label>
                          <textarea
                            id="message"
                            name="message"
                            rows={4}
                            required
                            maxLength={500}
                            className="w-full px-3 py-2 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                            placeholder="请输入您的留言内容（最多500字）"
                          ></textarea>
                          <p className="text-xs text-foreground-400 mt-1">最多500字</p>
                        </div>

                        <button
                          type="submit"
                          className="w-full py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                        >
                          提交留言
                        </button>

                        {formState === 'success' && (
                          <p className="text-sm text-accent-600 text-center">
                            感谢您的留言，我们会尽快回复！
                          </p>
                        )}
                        {formState === 'error' && (
                          <p className="text-sm text-red-500 text-center">
                            {formError || '提交失败，请稍后重试'}
                          </p>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}